import { Injectable } from '@angular/core';
// import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { CashlessPayment } from '../models';

const enum Api{
  PURSES = 'purses',
  PURSETOPUPOPTIONS = 'setpursetopupoptions',
  CASHLESSPAYMENT = 'payment/cashlesspayment',
}

@Injectable()
export class PurseService {
  constructor(
    private httpService: HttpService,
    ) {}

  public getPurses(): Observable<any> {
    return this.httpService.makeGet<void>(Api.PURSES,  null, null);
  }

  public setTopupOption(payload: any): Observable<any> {
    return this.httpService.makePost<any, any>(Api.PURSETOPUPOPTIONS, payload.purseTopupOptions);
  }

  public setCashlessPayment(payload: CashlessPayment): Observable<any> {
    return this.httpService.makePost<any, any>(Api.CASHLESSPAYMENT, payload);
  }

}
